import { Connection, Keypair, LAMPORTS_PER_SOL } from '@solana/web3.js';
import bs58 from 'bs58';

export async function getSolanaWallet(privateKey: string, rpcProvider: Connection): Promise<{ address: string; balance: number }> {
    const publicKey = Keypair.fromSecretKey(new Uint8Array(bs58.decode(privateKey))).publicKey;
    const lamports = await rpcProvider.getBalance(publicKey);

    return { address: publicKey.toBase58(), balance: lamports / LAMPORTS_PER_SOL };
}
